import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  key: 0,
  class: "dropdown-menu d-block",
  style: {"min-width":"100%"}
}
const _hoisted_4 = {
  key: 0,
  class: "dropdown-item-text fa-2x"
}
const _hoisted_5 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_6 = { class: "dropdown-item-text" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "form-control location-control",
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
      ref: "input",
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)), ["enter"])),
        _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.down && _ctx.down(...args)), ["down"])),
        _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.up && _ctx.up(...args)), ["up"]))
      ],
      onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
      onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args)))
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.searchQuery]
    ]),
    ((_ctx.groups.length > 0 && _ctx.focused) || _ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "fas fa-circle-notch fa-spin" }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (index !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("strong", null, _toDisplayString(group.text), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["dropdown-item", {'active text-white': _ctx.itemsById[item.id].index === _ctx.current}]),
                  ref_for: true,
                  ref: "results",
                  onClick: ($event: any) => (_ctx.selectOption(_ctx.itemsById[item.id].index))
                }, _toDisplayString(item.name), 11, _hoisted_7))
              }), 256))
            ], 64))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}